export default "__VITE_ASSET__HpjbaNQ0__"